export default "__VITE_ASSET__727f4ae3__"